import React, { Component } from "react";
import "./AmplusImmob.css";
import { connect } from "react-redux";
import _ from "lodash";
import actions from "../../store/actions";
import AmplusImmobAPI from "../../APIs/AmplusImmobAPI";

class AmplusImmob extends Component {
  state = {
    loading: false,
    selectedVehicle: null,
    dropdownOpen: false,
    searchText: "",
    startDate: "",
    endDate: "",
    cmdHistory: [],
    checkedStatusIds: [],
    activeCommand: null,
  };
  dropdownRef = React.createRef();

  componentDidMount() {
    document.addEventListener("click", this.handleOutsideClick);

    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);
  
    const formatDate = (d) => d.toISOString().split("T")[0]; // yyyy-mm-dd
  
    this.setState(
      {
        startDate: formatDate(lastWeek),
        endDate: formatDate(today),
      },
      () => {
        // ---- auto call history API after state set ----
        this.CmdHistory();
      }
    );
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (
      this.state.dropdownOpen &&
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(e.target)
    ) {
      this.setState({ dropdownOpen: false });
    }
  };

  notify = (name, content, showError = false) => {
    this.props.dispatch({
      type: actions.ADD_INTOAST,
      data: { name, content, createAt: Date.now(), autoClose: 8000, showError },
    });
  };

  getVehicleList = () => {
    const map = this.props.vehicleMap || {};
    const list = [];
    for (let key in map) {
      const v = map[key];
      if (v && v.type === "vehicle") list.push(v);
    }
    // return _.orderBy(list, ["vehicleno"], ["asc"]);
    return list;
  };

  handleSelectVehicle = (vehicle) => {
    this.setState({
      selectedVehicle: vehicle,
      dropdownOpen: false,
      searchText: "",
    });
  };

  toggleDropdown = () => {
    this.setState((prev) => ({ dropdownOpen: !prev.dropdownOpen }));
  };

  handleSearchChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleDateChange = (field, value) => {
    this.setState({ [field]: value });
  };

 

  immobilize = async () => {
    const vehicle = this.state.selectedVehicle;
  
    if (!vehicle) {
      return this.notify("Immobilize Command", "Please select a vehicle", true);
    }
  
    try {
      this.setState({ loading: true, activeCommand: "immobilize" });
  
      const payload = {
        vehicleno: vehicle.vehicleno,
        chassisno: vehicle.vehiclemeta?.chassisno,
      };
  
      const res = await AmplusImmobAPI.Immoblies(payload);
  
      // Handle both axios and direct responses
      const apiRes = res?.data ?? res;
  
      console.log("🔍 Immobilize API Response:", apiRes);
  
      // ✅ Only check outer status
      if (apiRes?.status?.toUpperCase?.() === "SUCCESS" || apiRes?.status?.toUpperCase?.() === "PENDING") {
        const successMsg =
          apiRes?.msg ||
          apiRes?.data?.message ||
          "Immobilize command executed successfully.";
        this.notify("Immobilize Command Sent", successMsg);
      } else {
        const msg =
          apiRes?.msg ||
          apiRes?.err ||
          apiRes?.data?.message ||
          "Failed to execute immobilize command.";
        this.notify("Immobilize Command Failed", msg, true);
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.msg ||
        error.response?.data?.err ||
        error.message ||
        "Something went wrong while sending immobilize command.";
  
      this.notify("Immobilize Command Failed", errorMsg, true);
    } finally {
      // this.setState({ loading: false, activeCommand: null });
      this.setState({ loading: false, activeCommand: null }, () => {
        this.CmdHistory();
      });
    }
  }; 
  
  

  mobilize = async () => {
    const vehicle = this.state.selectedVehicle;

    if (!vehicle) {
      return this.notify("Mobilize Command", "Please select a vehicle", true);
    }

    try {
      // this.setState({ loading: true });
      this.setState({ loading: true, activeCommand: "mobilize" });

      // Include chassisno if the API requires it
      const payload = {
        vehicleno: vehicle.vehicleno,
        chassisno: vehicle.vehiclemeta?.chassisno
      };

      console.log("Mobilize payload:", payload);

      const res = await AmplusImmobAPI.Mobilies(payload);

      if (res?.status === "SUCCESS" || res?.status === "PENDING") {
        this.notify("Mobilize Command Sent", "Mobilize command executed successfully.");
      } else {
        const msg = res?.data?.msg || res?.data?.err || "Failed to execute mobilize command.";
        this.notify("Mobilize Command Failed", msg, true);
      }
    } catch (error) {
      const errorMsg =
      error.response?.data?.msg ||
      error.response?.data?.err ||
      error.message ||
      "Something went wrong while sending the mobilize command.";

    this.notify("Mobilize Command Failed", errorMsg, true);
    } finally {
      // this.setState({ loading: false });
      // this.setState({ loading: false, activeCommand: null });
      this.setState({ loading: false, activeCommand: null }, () => {
        this.CmdHistory();
      });
    }
  };

  CmdHistory = async () => {
    const { startDate, endDate } = this.state;

    if (!startDate || !endDate) {
      return this.notify(
        "Please select both Start and End Date",
        "Please select both Start and End Date",
        true
      );
    }

    // const startEpoch = new Date(startDate).getTime();
    // const endEpoch = new Date(endDate).getTime();

    const startEpoch = new Date(startDate).setHours(0, 0, 0, 0);
    const endEpoch = new Date(endDate).setHours(23, 59, 59, 999);

    const payload = {
      starttime: startEpoch,
      endtime: endEpoch,
    };

    try {
      this.setState({ loading: true });
      const res = await AmplusImmobAPI.ListCmnds(payload);

      // Handle both array and object responses
      let commandData = [];

      if (Array.isArray(res)) {
        commandData = res;
      } else if (res && Array.isArray(res.data)) {
        commandData = res.data;
      } else if (res && res.status === "SUCCESS" && Array.isArray(res.data)) {
        commandData = res.data;
      }
      commandData = commandData.sort((a, b) => b.sentat - a.sentat);
      if (commandData.length > 0) {
        this.setState({ cmdHistory: commandData });
         this.notify("Command History", "Command history fetched successfully");
      } else {
        this.setState({ cmdHistory: [] });
        this.notify("Command History", "No command history found", true);
      }
    } catch (err) {
      this.notify("Command History", "Failed to fetch command history", true);
      this.setState({ cmdHistory: [] });
    } finally {
      this.setState({ loading: false });
    }
  };

  CmdStatus = async (cmndid, index) => {
    try {
      const res = await AmplusImmobAPI.CmdCommandStatus({ cmndid });
  
      let status;
      if (typeof res === "string") {
        status = res;
      } else if (res && res.status === "SUCCESS" && res.data) {
        status = res.data;
      } else if (res && res.data) {
        status = res.data;
      } else if (res && res.status) {
        status = res.status;
      }
  
      // Update row status
      const updatedHistory = [...this.state.cmdHistory];
      updatedHistory[index].status = status ?? "";
      this.setState({
        cmdHistory: updatedHistory,
        checkedStatusIds: [...this.state.checkedStatusIds, cmndid], // ✅ mark as checked
      });

      if (status) {
        this.notify("Command Status", `Command status fetched successfully: ${status}`);
      } else {
        this.notify("Command Status", "Command status not available", true);
      }
    } catch (err) {
      this.notify("Command Status", "Failed to fetch status", true);
    }
  };
  componentDidUpdate(prevProps) {
    const { amplusImmob, reportWindow } = this.props;
  
    // Only run when amplusImmob or reportWindow changes
    if (
      prevProps.amplusImmob !== amplusImmob ||
      prevProps.reportWindow?.visible !== reportWindow?.visible
    ) {
      console.log("1-- amplusImmob changed:", amplusImmob);
      console.log("2--- reportWindow.visible changed:", reportWindow?.visible);
    }
  }


  render() {
    const {
      selectedVehicle,
      dropdownOpen,
      searchText,
      startDate,
      endDate,
      cmdHistory,
    } = this.state;
    let vehicles = this.getVehicleList();

    if (searchText) {
      vehicles = vehicles.filter(
        (v) =>
          v.vehicleno.toLowerCase().includes(searchText.toLowerCase()) ||
          (v.vehiclechassisno &&
            v.vehiclechassisno.toLowerCase().includes(searchText.toLowerCase()))
      );
    }

    if (
      !(
        this.props.amplusImmob.active &&
        !this.props.reportWindow.visible &&
        !this.props.tableView.active
      )
    ) {
      return null;
    }


    
    return (
      
      <div className={"AmplusImmob " + (this.props.amplusImmob.active && this.props.reportWindow.visible  ? "active" : "")
      }>
        
        <div className="immob-header">
          {/* Vehicle Dropdown  gap-35px*/}
          <div style={{ display: "flex", justifyContent:"space-between",width:"100%"}}> 
            <div className="vehicle-dropdown" ref={this.dropdownRef}>
              <div
                className="vehicle-dropdown-toggle"
                onClick={this.toggleDropdown}
              >
                {selectedVehicle
                  ? `${selectedVehicle.vehicleno}`
                  : "Select a vehicle..."}
                <span className={`dropdown-icon ${dropdownOpen ? "open" : ""}`}>
                  ▼
                </span>
              </div>

              {dropdownOpen && (
                <div className="vehicle-dropdown-menu">
                  <div className="vehicle-search-container">
                    <input
                      type="text"
                      className="vehicle-dropdown-search"
                      value={searchText}
                      onChange={this.handleSearchChange}
                      placeholder="Search..."
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>

                  <ul className="vehicle-dropdown-options">
                    {vehicles.length ? (
                      vehicles.map((v) => (
                        <li
                          key={v.vehicleid}
                          onClick={() => this.handleSelectVehicle(v)}
                        >
                          {v.vehicleno}
                        </li>
                      ))
                    ) : (
                      <li className="no-results">No results found</li>
                    )}
                  </ul>
                </div>
              )}
            </div>

           
            <div className="button-group">
              <button
                onClick={this.immobilize}
                className="imm-btn"
                disabled={this.state.loading && this.state.activeCommand !== "immobilize"}
              >
              {this.state.loading && this.state.activeCommand === "immobilize" ? (
                  <span className="loader"></span>
                ) : null}
                Immobilize
              </button>

              <button
                onClick={this.mobilize}
                className="mm-btn"
                disabled={this.state.loading && this.state.activeCommand !== "mobilize"}
              >
              {this.state.loading && this.state.activeCommand === "mobilize" ? (
                  <span className="loader"></span>
                ) : null}
                Mobilize
              </button>
            </div>

          </div>
        </div>

        {/* {cmdHistory.length > 0 && ( */}
          <div className="cmd-history-container">
          {/* <h3>Command History</h3> */}
          <div style={{ display: "flex", justifyContent:"space-between"}}>
            <div className="date-cnt">
              <div className="date-field" style={{display:"flex",flexDirection:'row',alignItems:"center",gap:"20px"}}>
                <label>Start Date:</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) =>
                    this.handleDateChange("startDate", e.target.value)
                  }
                />
              </div>
              <div className="date-field" style={{display:"flex",flexDirection:'row',alignItems:"center",gap:'20px'}}>
                <label>End Date:</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) =>
                    this.handleDateChange("endDate", e.target.value)
                  }
                />
              </div>
            </div>

            <div className="button-group">
              <button
                onClick={this.CmdHistory}
                className="history-btn"
                disabled={this.state.loading}
              >
                History
              </button>
            </div>
          </div>

            <h3>Command History</h3>
            {cmdHistory.length > 0 && (
            <table className="cmd-history-table">
              <thead>
                <tr>
                  <th>Vehicle No</th>
                  <th>Command ID</th>
                  <th>Command</th>
                  <th>Sent At</th>
                  <th>Sent By</th>
                  <th>Status</th>
                  <th>Action</th> {/* Only this column has a header */}
                  {/* No header for Check Status button */}
                </tr>
              </thead>
              <tbody>
                {cmdHistory.map((cmd, index) => (
                  <tr key={cmd.cmndid}>
                    <td>{cmd.vehicleno}</td>
                    <td>{cmd.cmndid}</td>
                    <td
                      className={
                        cmd.command === "mobilize" ? "cmd-green" : "cmd-red"
                      }
                    >
                      {cmd.command}
                    </td>
                    <td>{new Date(cmd.sentat).toLocaleString()}</td>
                    <td>{cmd.sentby}</td>

                    {/* Status text */}
                    <td
                      className={
                        cmd.status === "SUCCESSFUL" ? "cmd-green" : "cmd-red"
                      }
                    >
                      {cmd.status || ""}
                    </td>

                    {/* Check Status button (no header) */}
                    {/* <td>
                      <button
                        className="status-btn"
                        onClick={() => this.CmdStatus(cmd.cmndid, index)}
                      >
                        Check Status
                      </button>
                    </td> */}

                    <td>
                      <button
                        className="status-btn"
                        onClick={() => this.CmdStatus(cmd.cmndid, index)}
                        // disabled={this.state.checkedStatusIds.includes(cmd.cmndid)} // ✅ disable once clicked
                      >
                          Check Status
                      </button>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          // </div>
        )}
         </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  vehicleMap: state.vehicleMap,
  // recentDevices: state.recentDevices,
  reportWindow: state.reportWindow,
  tableView: state.tableView,
  amplusImmob: state.amplusImmob,
});

export default connect(mapStateToProps)(AmplusImmob);
